import { makeRandomAlarm } from "@/mocks/fixtures/alarms"

import type { HubConnectionLike, HubName } from "./signalr"

type Handler = (payload: unknown) => void

/**
 * In-memory mock hub. Gerçek WebSocket yok.
 * deviceNotificationHub için: start() sonrası 20–40 saniye random aralıklarla
 * "ReceiveNotification" eventi üretir, payload `makeRandomAlarm()`.
 */
export function createMockHub(hubName: HubName): HubConnectionLike {
  const handlers = new Map<string, Set<Handler>>()
  let timer: ReturnType<typeof setTimeout> | null = null
  let state: "Disconnected" | "Connecting" | "Connected" = "Disconnected"

  function scheduleNext() {
    const delay = 20_000 + Math.floor(Math.random() * 20_000) // 20–40sn
    timer = setTimeout(() => {
      if (state !== "Connected") {
        return
      }
      if (hubName === "deviceNotificationHub") {
        const payload = makeRandomAlarm()
        emit("ReceiveNotification", payload)
      }
      scheduleNext()
    }, delay)
  }

  function emit(event: string, payload: unknown) {
    handlers.get(event)?.forEach((h) => {
      try {
        h(payload)
      } catch (err) {
        console.error("[mock-signalr] handler error", err)
      }
    })
  }

  return {
    get state() {
      return state
    },
    async start() {
      if (state !== "Disconnected") {
        return
      }
      state = "Connecting"
      // Küçük bir "handshake" gecikmesi simüle et
      await new Promise((r) => setTimeout(r, 100))
      state = "Connected"
      scheduleNext()
    },
    async stop() {
      state = "Disconnected"
      if (timer) {
        clearTimeout(timer)
        timer = null
      }
      handlers.clear()
    },
    on(event, handler) {
      let set = handlers.get(event)
      if (!set) {
        set = new Set()
        handlers.set(event, set)
      }
      set.add(handler as Handler)
    },
    off(event, handler) {
      handlers.get(event)?.delete(handler as Handler)
    },
  }
}
